import { ACTION_TYPES } from "../../../constants";

const initialState = {
  requesting: false,
  success: false,
  error: false,
  data: null,
};

const logoutReducer = (state = initialState, action = {}) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.AUTH.LOGOUT.SUCCESS: {
      return {
        success: true,
        requesting: false,
        error: false,
        data: payload,
      }
    }
    case ACTION_TYPES.AUTH.LOGOUT.REQUESTING:
      return { success: false, requesting: true, error: false };
    case ACTION_TYPES.AUTH.LOGOUT.ERROR:
      return { data: payload, success: false, requesting: false, error: true };
    case ACTION_TYPES.AUTH.LOGOUT.RESET:
      return initialState;
    default:
      return state
  }
}

export default logoutReducer